/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'
import { actionWithHooks } from 'lib/sequence/module/action'
import asObject from 'lib/sequence/component/children/asObject'
import { back } from 'app/_shared/events'

/**
 * Event Handler Step Previous.
 *
 * Subtracts one to the value of the activeStep property of the stepper used as child of the current
 * action component, then calls the current module's action.
 *
 * If the result of subtracting a step is less than zero, it calls {@link back} instead.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Event} event                 the event object that triggered this handler
 * @returns {Promise<void>}
 */
export default curry(async (module, component, event) => {
  try {
    const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
    const { stepper } = asObject(actionComponent[G.CHILDREN])
    const stepperState = stepper[G.STATE]
    const { activeStep = 0 } = stepperState
    const previousStep = activeStep - 1

    if (previousStep < 0) {
      await back(module, component, event)
    } else {
      const steps = stepper[G.CHILDREN]
      const visibleSteps = steps.filter((step) => {
        const { hidden } = { ...step[G.PROPS], ...step[G.STATE] }
        return !hidden
      })

      const stepsCount = visibleSteps.slice(previousStep)

      // go directly to the previous step (or to the first one)
      stepperState.activeStep = previousStep
      // call same action, see side effects
      await actionWithHooks(module[G.STATE][G.ACTION])([])
    }
  } catch (e) {
    console.error(e)
  }
})
